<template>
  <v-container fluid style="padding: 0; margin: 0;">
    <Logo :show="true" :isSwitchLanguage = "true" />
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-carousel hide-delimiter-background hide-delimiters :show-arrows="false" height="100vh">
          <v-carousel-item
            class="despre-noi-image"
            :src="require('../assets/images/' + datas.cover)"
            reverse-transition="fade-transition"
            transition="fade-transition"
          ></v-carousel-item>
          <v-overlay :absolute="true" :value="true">
            <h2 :class="styleFontResortName">{{datas.name | removeBr}}</h2>
            <br />
            <br />
            <br />
            <br />
            <br />
            <a href="#detail" class="btn-scroll" :class="styleFontBody">{{datas.message}}</a>

            <div class="container-click">
              <a class="text" href="#detail">
                <div class="chevron"></div>
                <div class="chevron"></div>
                <div class="chevron"></div>
              </a>
            </div>
          </v-overlay>
        </v-carousel>

        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <div class="message">{{datas.message}}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col offset-lg="1" offset-md="1" lg="9" md="9" sm="12" cols="12">
              <v-row id="detail">
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-carousel hide-delimiters class="slide-each-room-type" height="auto">
                    <v-carousel-item v-for="(data, index) in datas.roomType" :key="index">
                      <v-img
                        :src="data.img"
                        class="grey lighten-2"
                        contain
                        style="height: 100%; width: auto;"
                      >
                        <v-row>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <div class="display-resort-name" :class="styleFontTopic">{{data.name}}</div>
                          </v-col>
                        </v-row>
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-carousel-item>
                  </v-carousel>
                </v-col>

                <v-col lg="6" md="6" sm="12" cols="12" class="detail-resort">
                  <div
                    style="text-align: left; padding-top: 20px;"
                    v-html="datas.detail"
                    :class="styleFontBody"
                  ></div>
                  <br />
                  <div
                    style="text-align: left; font-weight: bold;"
                    :class="styleFontBody"
                  >{{datas.keyFeatureLabel}}</div>
                  <ul style="text-align: left" :class="styleFontBody">
                    <li
                      v-for="(dataKeyFeature, indexKeyFeature) in datas.keyFeatureList"
                      :key="indexKeyFeature"
                      v-html="dataKeyFeature"
                    ></li>
                  </ul>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="10" lg="10" offset-lg="1" offset-md="1">
              <Point :datas="points" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="10" lg="10" offset-lg="1" offset-md="1">
              <Seasonality :datas="seasonalities" />
            </v-col>
          </v-row>
        </v-container>

        <v-btn
          color="#b3a258"
          class="floating-button"
          large
          :to="bookNowLink"
          :style="fontSizeBookNow"
        >{{bookNowText}}</v-btn>
      </v-col>
    </v-row>
    <Footer></Footer>
  </v-container>
</template>
<script>
import Logo from "@/components/Logo.vue";
import Point from "@/components/Point.vue";
import Seasonality from "@/components/Seasonality.vue";
import Footer from "@/components/Footer.vue";

const axios = require("axios").default;

export default {
  name: "Destination",
  components: {
    Logo,
    Point,
    Seasonality,
    Footer
  },
  data() {
    return {
      des: this.$route.params.name,
      lang: this.$route.params.lang,
      points: [],
      seasonalities: [],
      datas: [],
      carouselHeight: 300,
      bookNowText: "",
      styleFontResortName: {},
      styleFontTopic: {},
      styleFontBody: {},
      fontSizeBookNow: {},
      bookNowLink: ""
    };
  },
  methods: {
    getPoint() {
      let self = this;
      axios
        .get("/data/destination/" + this.des + "/points-" + this.lang + ".json")
        // eslint-disable-next-line no-unused-vars
        .then(function(res) {
          self.points = res.data;
        });
    },
    getSeasonality() {
      let self = this;
      axios
        .get(
          "/data/destination/" +
            this.des +
            "/seasonality-" +
            this.lang +
            ".json"
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(res) {
          self.seasonalities = res.data;
        });
    },
    getData() {
      let self = this;

      if (self.lang == "en") {
        self.bookNowText = "BOOK NOW";
      } else if (self.lang == "cn") {
        self.bookNowText = "立即预订";
      } else if (self.lang == "th") {
        self.bookNowText = "จองตอนนี้";
        this.fontSizeBookNow = { "font-size": "20px" };
      }

      axios
        .get("/data/destination/" + this.des + "/data-" + this.lang + ".json")
        // eslint-disable-next-line no-unused-vars
        .then(function(res) {
          self.datas = res.data;
        });
    },
    loadStyle() {
      this.bookNowLink = {
        name: "home",
        params: { lang: this.lang },
        hash: "#enquiry"
      };

      if (this.lang == "th") {
        this.styleFontResortName = { th: true, "th-resort-name": true };
        this.styleFontTopic = { th: true, "th-topic": true };
        this.styleFontBody = { th: true };
      }
    }
  },
  filters: {
    removeBr(value) {
      return value.replace("<br>", " ");
    }
  },
  mounted() {
    this.getPoint();
    this.getSeasonality();
    this.getData();
    this.loadStyle();
  }
};
</script>

<style scoped>
/* .container {
  position: relative;
  width: 51px;
  height: 24px;
} */
.container-click {
  position: relative;
  width: 37px;
  height: 24px;
  margin: 0 auto;
  /* text-align: center; */
}
.chevron {
  position: absolute;
  width: 28px;
  height: 8px;
  opacity: 0;
  transform: scale3d(0.5, 0.5, 0.5);
  animation: move 3s ease-out infinite;
}
.chevron:first-child {
  animation: move 3s ease-out 1s infinite;
}

.chevron:nth-child(2) {
  animation: move 3s ease-out 2s infinite;
}
.chevron:before,
.chevron:after {
  content: " ";
  position: absolute;
  top: 0;
  height: 100%;
  width: 51%;
  background: #fff;
}

.chevron:before {
  left: 0;
  transform: skew(0deg, 30deg);
}

.chevron:after {
  right: 0;
  width: 50%;
  transform: skew(0deg, -30deg);
}

.message {
  font-size: 1.7em;
  color: #b3a258;
}
@keyframes move {
  25% {
    opacity: 1;
  }
  33% {
    opacity: 1;
    transform: translateY(30px);
  }
  67% {
    opacity: 1;
    transform: translateY(40px);
  }
  100% {
    opacity: 0;
    transform: translateY(55px) scale3d(0.5, 0.5, 0.5);
  }
}

.btn-scroll {
  cursor: pointer;
  color: #000;
  font-weight: bold;
  background-color: #fff;
  opacity: 0.6;
  border: 1px solid fff;
  top: 10%;
  padding: 8px;
  text-decoration: none;
}
.floating-button {
  position: fixed;
  bottom: 50px;
  color: #fff;
  right: 15px;
  /* top: 20px; */
  z-index: 9;
}
.container-text {
  position: absolute;
  background-color: #000;
  opacity: 0.4;
  z-index: 999;
}
.display-text {
  color: #fff;
  text-align: center;
  border: 1px solid eee;
  padding: 25px;
  background-color: #000;
  opacity: 0.7;
}
.display-resort-name {
  position: absolute;
  color: #fff;
  /* top: 100%; */
  left: 1px;
  bottom: 1px;
  background-color: #000;
  opacity: 0.8;
  z-index: 1;
  padding: 10px;
  width: 100%;
}
.despre-noi-image {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  -webkit-animation: zoomin 15s;
  animation: zoomin 15s;
  animation-fill-mode: both;
  animation-play-state: running;
}

/* @-webkit-keyframes zoomin { */
@keyframes zoomin {
  0% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.detail-resort {
  padding: 0 50px;
}

/* 
@media (max-width: 1920px) and (max-height: 1080px) { 
  .slide-each-room-type {
    height: 50vh !important;
  }
 }

  @media (max-width: 1366px) and (max-height: 768px) { 
  .slide-each-room-type {
    height: 45vh !important;
  }
 }
  @media (max-width: 1024px) and (max-height: 768px) { 
  .slide-each-room-type {
    height: 35vh !important;
  }
 }
  @media (max-height: 812px) { 
  .slide-each-room-type {
    height: 30vh !important;
  }
 }
  @media (max-height: 736px) { 
  .slide-each-room-type {
    height: 40vh !important;
  }
 }
 @media (max-height: 667px) { 
  .slide-each-room-type {
    height: 40vh !important;
  }
 } */
</style>